import $ from 'jquery';

// submit compliance
$("#btnSubmitCompliance").on('confirmed', function (e) {
    const form = $(this).closest("form");
    if (form.valid()) {
        // update hidden draft input
        $("#inputIsDraft").val('false');
        form.submit();
    }
});


// handle NPS score input
const ckComplianceFormNPSScoreValue = document.querySelector<HTMLInputElement>('#ckComplianceFormNPSScoreValue');
const txtComplianceFormNPSScoreValue = document.querySelector<HTMLInputElement>('#txtComplianceFormNPSScoreValue');
const txtComplianceFormNPSScoreValueAlt = document.querySelector<HTMLInputElement>('#txtComplianceFormNPSScoreValueAlt');
const ckComplianceFormNPSScoreNA = document.querySelector<HTMLInputElement>('#ckComplianceFormNPSScoreNA');

// check score input
if (ckComplianceFormNPSScoreValue && txtComplianceFormNPSScoreValue && txtComplianceFormNPSScoreValueAlt) {
    // enable input on checked
    ckComplianceFormNPSScoreValue.addEventListener("change", () => {
        // enable input
        txtComplianceFormNPSScoreValue.value = '';
        txtComplianceFormNPSScoreValueAlt.value = '';
        txtComplianceFormNPSScoreValueAlt.disabled = false;
    });

    if (ckComplianceFormNPSScoreNA.checked) {
        txtComplianceFormNPSScoreValue.value = 'N/A';
        txtComplianceFormNPSScoreValueAlt.disabled = true;
    } else if (!ckComplianceFormNPSScoreValue.checked) {
        txtComplianceFormNPSScoreValueAlt.disabled = true;
    }

    // set input value on alt input change
    txtComplianceFormNPSScoreValueAlt.addEventListener('input', () => {
        txtComplianceFormNPSScoreValue.value = txtComplianceFormNPSScoreValueAlt.value;
    });
}

// check n/a
if (ckComplianceFormNPSScoreNA && txtComplianceFormNPSScoreValue) {
    // enable input on checked
    ckComplianceFormNPSScoreNA.addEventListener("change", () => {
        // enable input
        txtComplianceFormNPSScoreValue.value = 'N/A';
        txtComplianceFormNPSScoreValueAlt.value = '';
        txtComplianceFormNPSScoreValueAlt.disabled = true;
    });
}